import styled from 'styled-components';

const Container = styled.div`
  width: 100%;

  /* ✅ Define uma largura máxima para o conteúdo. 
     1140px é um valor padrão e elegante para layouts modernos. */
  max-width: 90%; 
  
  /* Centraliza o container na página */
  margin-left: auto;
  margin-right: auto;
  
  /* Adiciona um "respiro" nas laterais para que o conteúdo nunca cole
     nos cantos, especialmente em telas de celular. */
  padding-left: 20px;
  padding-right: 20px;
`;

export default Container;